"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MenuHover = (function () {
    function MenuHover() {
        var _this = this;
        this.header = document.querySelector('header.desktop');
        this.mainMenuItems = this.header.querySelectorAll('.main-menu > .menu-item');
        this.mainMenuItemsCount = this.mainMenuItems.length;
        var _loop_1 = function (i) {
            var menuItem = this_1.mainMenuItems.item(i);
            menuItem.addEventListener('mouseover', function (e) {
                menuItem.classList.add('show-sub-nav');
            });
            menuItem.addEventListener('click', function (e) {
                if (e.target.classList.contains('more-toggle')) {
                    menuItem.classList.toggle('show-sub-nav');
                }
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.mainMenuItemsCount; ++i) {
            _loop_1(i);
        }
        this.header.addEventListener('mouseleave', function (e) {
            for (var i = 0; i < _this.mainMenuItemsCount; ++i) {
                var menuItem = _this.mainMenuItems.item(i);
                if (e.screenX > 0 && e.screenY > 0) {
                    menuItem.classList.remove('show-sub-nav');
                }
            }
        });
        for (var i = 0; i < this.mainMenuItemsCount; ++i) {
            var menuItem = this.mainMenuItems.item(i);
            menuItem.addEventListener('mouseenter', function (e) {
                for (var j = 0; j < _this.mainMenuItemsCount; ++j) {
                    var menuItem2 = _this.mainMenuItems.item(j);
                    if (e.target !== menuItem2) {
                        menuItem2.classList.remove('show-sub-nav');
                    }
                }
            });
        }
    }
    MenuHover.getInstance = function () {
        if (!this.instance) {
            this.instance = new MenuHover();
        }
        return this.instance;
    };
    return MenuHover;
}());
exports.default = MenuHover;
